
import axios from 'axios'
import https from 'https'

/**
 * RestSerivce node provides a wrapper around the axios library so that we can add additional
 * centralized behavior around requests and responses. It is designed to be used on the 'Server' not
 * the client.
 */
export default function useRestNode() {
  // const agent = new https.Agent({
  //   rejectUnauthorized: true,
  // })

  function isHttps(url) {
    if (!url) return false
    return url.toLowerCase().startsWith('https')
  }

  function get(url, headers) {
    const promise = new Promise(async (resolve, reject) => {
      try {
        let config = { 
          headers: {}, 
          // Set timeout to 20 seconds (20000 ms),
          // in case of a slow response from API calls to get resouces
          // such as, get doctor or clinic photos from AEM via photo service
          timeout: 20000
        }
        //config.httpsAgent = isHttps(url) ? agent : {}
        //Add headers propagated by the /src/server/headers.js middleware
        if (axios.headers) {
          const xHPrequestId = axios.headers['x-hp-request-id']
          if (xHPrequestId) {
            config.headers = {
              'x-hp-request-id': xHPrequestId,
            }
          }
        }

        const { headers: hdrs } = config
        config.headers = headers ? { ...hdrs, ...headers } : hdrs
        //const result = await axios.get(url, config)
        const result = await axios.get(url, config)
        resolve(result.data)
      } catch (error) {
        //console.log(error)
        reject(error)
      }
    })

    return promise
  }

  function post(url, payload, headers) {
    const promise = new Promise(async (resolve, reject) => {
      try {
        let config = {}

        //Add headers propagated by the /src/server/headers.js middleware
        if (axios.headers) {
          const xHPrequestId = axios.headers['x-hp-request-id']
          if (xHPrequestId) {
            config.headers = {
              'x-hp-request-id': xHPrequestId,
            }
          }
        }
        const { headers: hdrs } = config
        config.headers = headers ? { ...hdrs, ...headers } : hdrs
        const result = await axios.post(url, payload, config)
        resolve(result.data)
      } catch (error) {
        //console.log(error)
        reject(error)
      }
    })

    return promise
  }

  return { get, post }
}
